

const BLOCK_UNIT = 512;

// 파형을 분석해서 진폭을 반환한다.
// 512는 TF SPICE에서 주는 값과 크기를 맞추기 위해서, 512 단위로 계산함.
export function getWavAmplitude(arrWav: Array<number>): Array<number> {
  const ret: Array<number> = [];
  let maxValue = null;
  arrWav.forEach((value, idx) => {
    value = Math.abs(value);
    maxValue = maxValue ? (maxValue < value ? value : maxValue) : value;

    if (idx % BLOCK_UNIT === 0 || idx === arrWav.length - 1) {
      ret.push(maxValue);
      maxValue = null;
    }
  });
  return ret;
}



/**
 * RMS (Root Mean Square) 정규화
 *
 * @param audioBuffer
 * @param targetRMS
 */
export function rmsNormalization(audioBuffer: Float32Array, targetRMS: number = 0.5): Float32Array {
  let sumSquare = 0;
  for (let i = 0; i < audioBuffer.length; i++) {
    sumSquare += audioBuffer[i] * audioBuffer[i];
  }
  const rms = Math.sqrt(sumSquare / audioBuffer.length);

  const normalizedBuffer = new Float32Array(audioBuffer.length);
  for (let i = 0; i < audioBuffer.length; i++) {
    normalizedBuffer[i] = (audioBuffer[i] / rms) * targetRMS;
  }

  return normalizedBuffer;
}
